import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Moment from 'moment';
import { ImInfo } from 'react-icons/im';
import ReactTooltip from 'react-tooltip';
import { Table, Thead, Tbody, Td, Tr } from 'react-super-responsive-table';
import ReactHtmlParser from 'react-html-parser';
import Button from '../../components/button/button';
import { QUESTIONS, PAYMENT_SCHEDULE_INTRO } from '../../constants.jsx';
import CurrencyInput from '../../components/currencyinput/static';
import HeaderTable from '../../components/headertable/headertable';
import Disclaimer from '../../components/disclaimer/disclaimer';
import { resize } from '../../utils/calculate';

const Question3 = props => {
  const {
    onFinish,
    onBack,
    onReset,
    amountRemainingToday,
    interestRemainingToday,
    futureDisclaimer,
    question3HelpText,
    disclaimer,
    incurredDate: [incurredDate],
    incurredAmount: [incurredAmount],
    finalPaymentDate: [finalPaymentDate],
    hasInstallments,
  } = { ...props };

  React.useEffect(() => {
    resize();
  });

  const amountRounded = parseFloat(amountRemainingToday).toFixed(2);
  const interestRounded = parseFloat(interestRemainingToday).toFixed(2);
  const today = new Date();

  const finalPaymentDateString = Moment(finalPaymentDate).format('DD/MM/YYYY');
  const overpayment = amountRemainingToday < 0;

  const isFuturePaymentDate = !!Moment(finalPaymentDate).isAfter(Moment(today));

  let verb = 'is';
  if (finalPaymentDate.toDateString() !== today.toDateString()) {
    verb = isFuturePaymentDate ? 'will be' : 'was';
  }

  return (
    <>
      <h3>
        Based on the information you have provided.
        {question3HelpText.length ? (
          <a data-event="click" type="submit" data-tip data-for="tooltip1">
            <ImInfo className="help-text-button" />
          </a>
        ) : null}
      </h3>
      {question3HelpText.length ? (
        <ReactTooltip
          globalEventOn="click"
          globalEventOff="click"
          id="tooltip1"
          place="bottom"
          effect="solid"
        >
          <div>{question3HelpText}</div>
        </ReactTooltip>
      ) : null}
      <HeaderTable
        startDate={incurredDate}
        finalDate={finalPaymentDate}
        amount={incurredAmount}
      />

      <br />
      <p>
        On the {finalPaymentDateString}, your balance {verb}
      </p>
      <Table className="heading-table large">
        <Thead>
          <Tr className="heading-table__row heading-table__row--heading">
            <Td
              className="heading-table__col heading-table__col--heading"
              id="total-amount-title"
            >
              {overpayment ? 'Overpayment' : 'Debt incl. interest'}
            </Td>
            {!overpayment ? (
              <Td
                className="heading-table__col heading-table__col--heading"
                id="total-interest-title"
              >
                Interest
              </Td>
            ) : null}
          </Tr>
        </Thead>
        <Tbody>
          <Tr className="heading-table__row heading-table__row--body">
            <Td className="heading-table__col heading-table__col--body">
              <CurrencyInput
                className="large"
                value={Math.abs(amountRounded)}
                label="total-amount-title"
              />
            </Td>
            {!overpayment ? (
              <Td className="heading-table__col heading-table__col--body">
                <CurrencyInput
                  className="large"
                  value={interestRounded}
                  label="total-interest-title"
                />
              </Td>
            ) : null}
          </Tr>
        </Tbody>
      </Table>

      {overpayment ? (
        <>
          <br />
          <Alert key={0} variant="warning">
            {ReactHtmlParser(QUESTIONS.OVERPAYMENT)}
          </Alert>
        </>
      ) : null}

      <br />

      {!overpayment ? (
        <>
          {isFuturePaymentDate ? (
            <Alert key={0} variant="warning">
              {futureDisclaimer}
            </Alert>
          ) : null}
        </>
      ) : null}
      <br />

      {hasInstallments ? <p>{PAYMENT_SCHEDULE_INTRO}</p> : null}

      <Row className="button-wrapper">
        <Col className="no-margin">
          <Button title="Back" variant="secondary" onClick={onBack} />
          {hasInstallments ? (
            <Button
              title="Payment schedule"
              variant="primary"
              onClick={onFinish}
            />
          ) : null}
        </Col>
        {!hasInstallments ? (
          <Col>
            <Button title="Start again" variant="primary" onClick={onReset} />
          </Col>
        ) : null}
      </Row>

      <Disclaimer content={disclaimer} />
    </>
  );
};

export default Question3;
